export const SECTION_CLASSNAME = 'dnd-section';
export const COLUMN_CLASSNAME = 'dnd-column';
export const ROW_CLASSNAME = 'dnd-row';
export const MODULE_CLASSNAME = 'dnd-module';
export const CUSTOM_CSS_CLASS_PARAM_KEY = 'css_class';
export const CUSTOM_CSS_ID_PARAM_KEY = 'css_id';
export const CUSTOM_CSS_ID_STR_PARAM_KEY = 'css_id_str';
export const CUSTOM_CSS_STYLE_PARAM_KEY = 'css_style';
export const CUSTOM_CSS_PARAM_NAMES = [CUSTOM_CSS_CLASS_PARAM_KEY, CUSTOM_CSS_ID_PARAM_KEY, CUSTOM_CSS_ID_STR_PARAM_KEY, CUSTOM_CSS_STYLE_PARAM_KEY];